module.exports = __webpack_public_path__ + "static/media/vp_contest.29dcf490.png";